import { AUTO, BOTTOM, DEFAULT_SHAPE_HEIGHT, DEFAULT_SHAPE_MINHEIGHT, DEFAULT_SHAPE_MINWIDTH, DEFAULT_SHAPE_POSITION, DEFAULT_SHAPE_TYPE, DEFAULT_SHAPE_WIDTH, LEFT, RIGHT, SHAPE, TOP } from './../constants';
import { simpleExtend } from './../utils';
export const DefaultConnectors = [{
        name: TOP
    }, {
        name: BOTTOM
    }, {
        name: LEFT
    }, {
        name: RIGHT
    }, {
        name: AUTO,
        position: function (shape) {
            return shape.getPosition('center');
        }
    }];
export const shapeDefaults = function (extra) {
    const defaults = {
        type: DEFAULT_SHAPE_TYPE,
        path: '',
        autoSize: true,
        visual: null,
        x: DEFAULT_SHAPE_POSITION,
        y: DEFAULT_SHAPE_POSITION,
        minWidth: DEFAULT_SHAPE_MINWIDTH,
        minHeight: DEFAULT_SHAPE_MINHEIGHT,
        width: DEFAULT_SHAPE_WIDTH,
        height: DEFAULT_SHAPE_HEIGHT,
        cornerRadius: 0,
        tooltip: {
            visible: true
        },
        hover: {},
        accessibility: {
            role: 'graphics-symbol',
            ariaRoleDescription: SHAPE
        },
        editable: {
            connect: true,
            tools: []
        },
        connectors: DefaultConnectors,
        rotation: {
            angle: 0
        }
    };
    simpleExtend(defaults, extra);
    return defaults;
};
